import { forwardRef } from "react"

import Email from './Email.jsx'
import Input from './Input.jsx'
import Password from './Password.jsx'
import Hidden from "./Hidden.jsx"
import Select from "./Select.jsx"
import Score from "./Score.jsx"
import AutoComplete from "./AutoComplete.jsx"
import Textarea from "./Textarea.jsx"

const InputFactory = forwardRef(function InputFactory({type, error, options, ...props}, ref) {
  let inputJSX

  switch (type.toUpperCase()) {
    case 'EMAIL':
      inputJSX = <Email ref={ref} error={error} {...props}/>
    break
    case 'PASSWORD':
      inputJSX = <Password ref={ref} error={error} {...props}/>
    break
    case 'HIDDEN':
      inputJSX = <Hidden ref={ref} {...props}/>
    break
    case 'SELECT':
      inputJSX = <Select ref={ref} options={options} error={error} {...props}/>
    break
    case 'SCORE':
      inputJSX = <Score ref={ref} options={options} error={error} {...props}/>
    break
    case 'AUTO_COMPLETE':
      inputJSX = <AutoComplete ref={ref} options={options} error={error} {...props}/>
    break
    case 'TEXTAREA':
      inputJSX = <Textarea ref={ref} error={error} {...props}/>
    break
    default:
      inputJSX = <Input ref={ref} error={error} {...props}/>
  }

  return (
    inputJSX
  )
})

export default InputFactory
